// widget mpid 身分解析：唯讀宿主 sdk-idsync；本模組不碰 localStorage、不自產 id。
// 兩段 cascade：顯式 mpid（host）＞ 宿主 sdk-idsync getId()（sdk）。兩者都拿不到 → 空 id（none）。
// id 一律當 opaque 字串看待（現為 mParticle MPID、未來可能 UUID）。
export type MpidSource = 'host' | 'sdk' | 'none'
export interface ResolvedMpid { id: string, source: MpidSource }

// 宿主 SDK 形狀（鬆散；不存在或未就緒都回 null）。只讀，不呼叫 init（那是宿主的事）。
interface IdSyncGlobal { isReady?: () => boolean, getId?: () => string | null }

function readSdkId(): string | null {
  const sdk = (globalThis as { TVBS_IDSync?: IdSyncGlobal }).TVBS_IDSync
  if (!sdk || typeof sdk.isReady !== 'function' || typeof sdk.getId !== 'function')
    return null
  if (!sdk.isReady())
    return null
  return sdk.getId() || null
}

// explicit = 元件 mpid 屬性值（可能為空字串）。
// idsync 拿不到 id 時回空 id：SDK 不自建匿名身分（下游 serve/submit 會省略 mp_id）。
export function resolveMpid(explicit: string): ResolvedMpid {
  if (explicit)
    return { id: explicit, source: 'host' }
  const sdkId = readSdkId()
  if (sdkId)
    return { id: sdkId, source: 'sdk' }
  return { id: '', source: 'none' }
}
